import { useRef, useEffect } from "react";
import { parse, format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import { DefaultHeading } from "../ScreenHeading";
import { Close } from "../../assets/svgs";
import "./styles.scss";

const PaymentCard = ({ date, amount, isLast = false }) => {
  return (
    <div
      className="payment-card"
      style={{ marginBottom: isLast ? "1.625rem" : 0 }}
    >
      <div className="payment-card__date">{date}</div>

      <div className="payment-card__amount">
        {amount} <span className="icon-saudi_riyal" />
      </div>
    </div>
  );
};

// Static Component
const PaymentPlanModal = ({ visible, payments = [], onClickClose }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const contentRef = useRef(null);

  const convertDate = value => {
    if (!value) return "";

    const parsed = parse(value, "dd/MM/yyyy", new Date());

    return format(parsed, "dd MMM yyyy");
  };

  const getTotalPayment = () => {
    return payments.reduce((sum, item) => {
      const payment = Number(item.payment?.toString().replace(/,/g, "")) || 0;
      return sum + payment;
    }, 0);
  };

  useEffect(() => {
    if (visible && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [visible]);

  return (
    <div className={`payment-plan-modal ${visible ? "show" : "hide"}`}>
      <div className="payment-plan-modal-content" ref={contentRef}>
        <Header
          containerStyle={"d-flex justify-content-end w-100"}
          rightIcon={Close}
          onClickRightIcon={onClickClose}
          rightIconStyle={{
            width: "1.25rem",
            height: "1.25rem",
            marginRight: "1.5rem",
            cursor: "pointer",
          }}
        />
        <DefaultHeading
          heading={"payment_plan"}
          description={"payment_plan_description"}
          style={{ headingFontSize: 32, descriptionFontSize: 16 }}
        />
        <div className="payment-timeline-item">
          {payments.map((item, index) => {
            const isLast = index === payments.length - 1;
            return (
              <>
                <PaymentCard
                  date={convertDate(item.paymentDate)}
                  amount={item.payment}
                  isLast={isLast}
                />
                {!isLast && <div className="payment-timeline-item__line"></div>}
              </>
            );
          })}
        </div>
        <div className="total-payment-card">
          <div className="total-payment-card__label">
            {t(`${routeName}.total_amount_due`)}
          </div>
          <div className="total-payment-card__amount">
            <span className="icon-saudi_riyal" /> {getTotalPayment().toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPlanModal;
